module.exports = __webpack_public_path__ + "images/menu_selected.gif";